import { render } from 'datocms-structured-text-to-html-string';
import { getBreadcrumbs } from './url-helpers';

export const getOrganizationSeoSchema = ({ data, url }) => {
	if (!data || !url) return;

	return {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		url,
		'logo': data.datoCmsSiteSpecificSetting?.logo?.url,
	};
};

export const getImageSeoSchema = (image) => {
	if (!image?.url) return;

	return {
		'@context': 'https://schema.org/',
		'@type': 'ImageObject',
		'contentUrl': image?.url,
		'creditText': 'Peninsula',
	};
};

export const getBreadcrumbsSeoSchema = ({
	pageType,
	location,
	data,
	parentPageData,
}) => {
	const breadCrumbItems = getBreadcrumbs(pageType, data, parentPageData);
	const breadCrumbItemsLength = breadCrumbItems.length - 1;
	const itemListElement = breadCrumbItems.map((item, index) => {
		const itemObj = {
			'@type': 'ListItem',
			'position': item.hierarchyPosition,
			'name': item.title,
		};

		if (index !== breadCrumbItemsLength) {
			itemObj.item = `${location.origin}/${item.url}`;
		}

		return itemObj;
	});

	return {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement,
	};
};

export const getFAQSeoSchema = (faqQuestions) => {
	if (!faqQuestions) return;

	const mainEntity = faqQuestions.map(({ question, answer }) => ({
		'@type': 'Question',
		'name': question,
		'acceptedAnswer': {
			'@type': 'Answer',
			'text': render({
				type: 'root',
				children: answer,
			}),
		},
	}));

	return {
		'@context': 'https://schema.org/',
		'@type': 'FAQPage',
		mainEntity,
	};
};

export const getLocalBusinessSeoSchema = ({ locations, url }) => {
	if (!locations.length) return;

	const hqCountry = 'United Kingdom';
	const hqCity = 'Manchester';
	const hqGeoCoordinates = {
		latitude: 53.4893675,
		longitude: -2.2411016,
	};

	const ukLocation = locations.find(
		(location) => location.name === hqCountry
	);

	if (!ukLocation) return;

	const hqLocation = ukLocation?.locations.find(
		(location) => location.name === hqCity
	);
	const otherLocations = ukLocation?.locations.filter(
		(location) => location.name !== hqCity
	);

	const [hqName, ...hqAddress] = hqLocation.address.split('\n');

	const addressSchema = [
		'streetAddress',
		'addressRegion',
		'postalCode',
		'addressCountry',
	];

	const hqAddressObj = addressSchema.map((schemaItem, index) => ({
		[schemaItem]: hqAddress[index],
	}));

	const otherDepartments = otherLocations.map(
		({ name, image, contactDetails }) => ({
			'@type': name,
			'image': [image.url],
			name,
			'telephone': contactDetails[0]?.phoneNumber,
		})
	);

	return {
		'@context': 'https://schema.org/',
		'@type': 'LocalBusiness',
		'image': [hqLocation.image.url],
		'name': hqName,
		'address': {
			'@type': 'PostalAddress',
			...Object.assign({}, ...hqAddressObj),
		},
		'geo': {
			'@type': 'GeoCoordinates',
			...hqGeoCoordinates,
		},
		url,
		'telephone': hqLocation.contactDetails[0]?.phoneNumber,
		'department': otherDepartments,
	};
};
